import { api, apiRequest } from "./api";

export interface Disease {
  id: string;
  long_name: string;
  short_name: string;
  other_names?: string | null;
  display_name?: string | null;
  widely_prevalent: boolean;
  family_linked: boolean;
  icd10_code?: string | null;
  created_by?: string | null;
  is_active: boolean;
  is_featured: boolean;
  created_at: string;
  updated_at: string;
}

export interface DiseasePayload {
  long_name: string;
  short_name: string;
  other_names?: string;
  display_name?: string;
  widely_prevalent?: boolean;
  family_linked?: boolean;
  icd10_code?: string;
  is_featured?: boolean;
}

export interface DiseaseListParams {
  search?: string;
  page?: number;
  page_size?: number;
  widely_prevalent?: boolean;
  family_linked?: boolean;
  is_featured?: boolean;
}

export interface PaginatedDiseaseResponse {
  count: number;
  next: string | null;
  previous: string | null;
  results: Disease[];
}

const buildDiseaseQuery = (params?: DiseaseListParams) => {
  const queryParams = new URLSearchParams();
  if (params?.search) queryParams.append("search", params.search);
  if (params?.page) queryParams.append("page", params.page.toString());
  if (params?.page_size)
    queryParams.append("page_size", params.page_size.toString());
  if (params?.widely_prevalent !== undefined) {
    queryParams.append("widely_prevalent", String(params.widely_prevalent));
  }
  if (params?.family_linked !== undefined) {
    queryParams.append("family_linked", String(params.family_linked));
  }
  if (params?.is_featured !== undefined) {
    queryParams.append("is_featured", String(params.is_featured));
  }
  const queryString = queryParams.toString();
  return `/internal/diseases/${queryString ? `?${queryString}` : ""}`;
};

export const diseasesAPI = {
  list: async (params?: DiseaseListParams): Promise<PaginatedDiseaseResponse> =>
    apiRequest(() => api.get(buildDiseaseQuery(params))),

  get: async (id: string): Promise<Disease> =>
    apiRequest(() => api.get(`/internal/diseases/${id}/`)),

  create: async (data: DiseasePayload): Promise<Disease> =>
    apiRequest(() => api.post("/internal/diseases/", data)),
};
